import React, { FC, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Collapse } from 'bootstrap';
import { Select, SelectType } from '@components/atoms/Select';
import { Typography } from '@components/atoms/Typography';
import { ResultsType } from '@types';
import { getDynamicMenuItemValue } from '@utils/translation';
import { useData } from '@hooks/useData';
import styles from './ResultsPageTop.module.css';

export interface ResultsPageTopProps {
    type: ResultsType;
    total: number;
    order: {
        options: { value: string; text: string }[];
        onChange: (value: string) => void;
    };
    sidebar: Collapse | null;
}

export const ResultsPageTop: FC<ResultsPageTopProps> = ({ type, total, order, sidebar }) => {
    const { t, i18n } = useTranslation();
    const { allSettings } = useData();
    const [translations, setTranslations] = useState({
        totalProducts: '',
        totalMerchants: '',
        totalServices: '',
        totalPointsServices: '',
        filterLabel: '',
        orderByLabel: '',
    });

    const [totalText, setTotalText] = useState('');

    const openSidebar = () => {
        sidebar?.show();
    };

    useEffect(() => {
        if (!allSettings?.data) return;

        const newTranslations = {
            totalProducts: t('results-container-component.total-of') + getDynamicMenuItemValue(allSettings.data, 1),
            totalMerchants: t('results-container-component.total-of') + getDynamicMenuItemValue(allSettings.data, 3),
            totalServices: t('results-container-component.total-of') + getDynamicMenuItemValue(allSettings.data, 2),
            totalPointsServices: t('results-container-component.total-points-services'),
            filterLabel: t('results-container-component.filter.label'),
            orderByLabel: t('results-container-component.order-by.label'),
        };

        setTranslations(newTranslations);

        // pick correct total text based on type
        switch (type) {
            case ResultsType.products:
                setTotalText(newTranslations.totalProducts);
                break;
            case ResultsType.merchants:
                setTotalText(newTranslations.totalMerchants);
                break;
            case ResultsType.services:
                setTotalText(newTranslations.totalServices);
                break;
            case ResultsType.pointsServices:
                setTotalText(newTranslations.totalPointsServices);
                break;
            default:
                setTotalText('');
                break;
        }
    }, [type, t, i18n.language, allSettings?.data]);

    return (
        <>
            <div className="d-flex align-items-center pb-3">
                <div className={`${styles['total-results']} d-none d-lg-grid flex-grow-1 align-content-center`}>
                    <Typography classes="mb-0" fontSize="16">
                        <>
                            {totalText}: {total}
                        </>
                    </Typography>
                </div>
                <div className="d-block d-lg-none flex-grow-1">
                    <button onClick={() => openSidebar()}>
                        <i className="fa-light fa-filter me-2"></i>
                        {translations.filterLabel}
                    </button>
                </div>
                {order.options.length > 0 && (
                    <div className="d-flex align-items-center">
                        <Typography classes="d-none d-lg-block text-nowrap mb-0 me-3" fontSize="16">
                            {translations.orderByLabel}
                        </Typography>
                        <div className="ms-3">
                            <Select type={SelectType.variant2} width="182px" {...order} />
                        </div>
                    </div>
                )}
            </div>
            <hr className="mt-0 mb-3" />
        </>
    );
};
